import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getElems, onReady, onScroll, sectionIsInView } from "../../tools/utilities/helper-functions";
var CLASS_IS_VISIBLE = 'is-visible';
onReady(function () {
  var allSections = getElems('.c-section');
  onScroll(function () {
    allSections.forEach(function (section) {
      if (sectionIsInView(section)) {
        section.classList.add(CLASS_IS_VISIBLE);
      } else {
        section.classList.remove(CLASS_IS_VISIBLE);
      }
    });
  });
});